import React,{useState, useEffect, createContext} from 'react';
import axios from 'axios'

export const MovieContext = createContext()


export const MovieProvider = ({children}) => {

    const [movies,setMovies] = useState([])
    const [query, setQuery] = useState()
    const [category, setCategory] = useState('top_rated')
    const [genreId, setGenreId] = useState('28')
    const [sort, setSort] = useState()
    const [isLoading, setIsLoading] = useState(true)
    const [totalResults,setTotalResults] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)

useEffect(() => {
   
    const fetchQueryMovies = async() => {
        const result = await axios(`https://api.themoviedb.org/3/search/movie?query=${query}&api_key=7b6a4aaf8e531cac206a64fde6c9137b`)
        setMovies(result.data.results)
        console.log(result.data.results)
        setTotalResults(result.data.total_results)
    }
    fetchQueryMovies()
},[query]);

useEffect(() => {
    setIsLoading(true)
    const fetchGenreMovies = async() => {
        const result = await axios(`https://api.themoviedb.org/3/discover/movie?api_key=7b6a4aaf8e531cac206a64fde6c9137b&with_genres=${genreId}&sort_by=${sort}`)
        setMovies(result.data.results)
        console.log(result.data.results)
        setTotalResults(result.data.total_results)
        console.log(result.data.total_results)
    }
    fetchGenreMovies()
    setIsLoading(false)
},[genreId, sort]);

useEffect(() => {
    setIsLoading(true)
    const fetchCategoryMovies = async() => {
        const result = await axios(`https://api.themoviedb.org/3/movie/${category}?api_key=7b6a4aaf8e531cac206a64fde6c9137b`);
        setMovies(result.data.results)
        console.log(result.data.results)
        setTotalResults(result.data.total_results)
        console.log(result.data.total_results)
    }
    fetchCategoryMovies()
    setIsLoading(false)
},[category]);


const nextPage = (pageNumber) => {
    
    const fetchItems = async() => {
     
      const result = await axios(`https://api.themoviedb.org/3/discover/movie?api_key=7b6a4aaf8e531cac206a64fde6c9137b&with_genres=${genreId}&sort_by=${sort}&page=${pageNumber}`)
      console.log(result.data)
      console.log(result.data.results[0])
      setMovies(result.data.results);
      setCurrentPage(pageNumber)
      setIsLoading(false)
      }
      fetchItems()
  }

  
// const nextPageCategory = (pageNumber) => {
    
//     const fetchItems = async() => {
//       const result = await axios(`https://api.themoviedb.org/3/discover/movie?api_key=7b6a4aaf8e531cac206a64fde6c9137b&with_genres=${genreId}&sort_by=${sort}&page=${pageNumber}`)
//       console.log(result.data)
//       console.log(result.data.results[0])
//       setMovies(result.data.results);
//       setCurrentPage(pageNumber)
//       setIsLoading(false)
//       }
//       fetchItems()
//   }


    return (
          <MovieContext.Provider value={{movies, setGenreId, setCategory, setSort, query, setQuery, isLoading, totalResults, nextPage, currentPage, setCurrentPage}}>
             {children}
         </MovieContext.Provider>    

    );
}

export default MovieContext;